"use client";
import "./FiltersChips.scss";
import { Row } from "@/components";
import { PropsWithChildren } from "react";
import clsx from "clsx";

export type ChipItem = {
  value: string;
  label: string;
};

type FiltersChipsProps = PropsWithChildren<{
  chips: (string | ChipItem)[];
  id: string;
  additionalClassName?: string;
  onChange: (selectedChip: string) => void;
  selectedChip?: string;
}>;

function getChipValue(chip: string | ChipItem): string {
  return typeof chip === "string" ? chip : chip.value;
}

function getChipLabel(chip: string | ChipItem): string {
  return typeof chip === "string" ? chip : chip.label;
}

export const FiltersChips = ({
  chips,
  id,
  additionalClassName,
  onChange,
  selectedChip,
}: FiltersChipsProps) => {
  return (
    <div
      className={clsx("filters-chips-container", additionalClassName)}
      role="radiogroup"
      aria-label="Filter options"
    >
      <Row alignItems="center" gap="x8" flexWrap="wrap">
        {chips.map((chip) => {
          const value = getChipValue(chip);
          const label = getChipLabel(chip);
          return (
            <button
              key={`${id}-${value}`}
              className={clsx("filter-chip", {
                "filter-chip--selected": selectedChip === value,
              })}
              role="radio"
              aria-checked={selectedChip === value}
              onClick={() => onChange(value)}
            >
              {label}
            </button>
          );
        })}
      </Row>
    </div>
  );
};
